<template>
  <div class="navbar-select-panel">
    <!-- Default option when no options available -->
    <div v-if="!options.length && defaultItem" class="navbar-select-el">
      {{ defaultItem }}
    </div>

    <!-- Options list -->
    <div
      v-for="item in options"
      :key="item.id"
      :value="item.id"
      :class="[{ selected: item.id == selectedId }, ...itemClass]"
      class="navbar-select-el"
      @click="$emit('itemSelected', item.id)"
    >
      <!-- Option template -->
      <slot name="item" :data="item">
        {{ item }}
      </slot>
    </div>

  </div>
</template>

<script>
// @group Navbar
// Navbar select
export default {
  name: "NavbarSelect",
  props: {
    /** options list, every option must have id */
    options: {
      type: [Array, Object],
      default: () => []
    },
    /** selected option id */
    selectedId: {
      type: [String, Number],
      default: null
    },
    /** option classes array */
    itemClass: {
      type: Array,
      default: () => []
    },
    /** default text when no option available */
    defaultItem: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.navbar-select-panel {
  background-color: #233d4e;
}

.navbar-select-el:hover {
  background-color: var(--dark-grey);
}
.navbar-select-el.selected {
  background-color: var(--dark-grey);
}
.navbar-select-el {
  color: white;
  cursor: pointer;
  padding: 5px 15px 5px 15px;
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .navbar-select-panel {
    border: 1px solid var(--light-grey);
    padding: 10px 0px 10px 0px;
    border-radius: 0.25em;
  }
}
</style>
